import React, {useState} from 'react';
import { BackgroundVideo, CustomCarousel, Navbar } from '../../../components';
import { Box, Button, Typography } from '@mui/material';

//import assets
import { home1, home2, home3} from '../../../assets'


const HomeHero = () => {
    const carouselItems = [
        {name: 'slide1', video: home1 },
        {name: 'slide2', video: home2 },
        {name: 'slide3', video: home3 },
    ]

  return (
    <Box
        sx={{
            width: '100%',
            minHeight: '100vh',  // Ensures it takes full screen height
            overflow: 'hidden', // Prevents unwanted extra space
            position: 'relative' // Ensures children don't overflow
        }}
    >
        <CustomCarousel
            showControls={false}
                sx={{
                    position:'absolute'
                }}
            >
                {carouselItems.map((item, index) => (
                        <BackgroundVideo
                            key={index}
                            video={item.video}
                            sx={{
                                zIndex:'-1'
                            }}
                        />
                ))}
            </CustomCarousel>

        <Box
            sx={{
                width:'100%',
                minHeight:'100vh',
                // backgroundColor:'rgba(50, 50, 50, 0.3)',
                background:'linear-gradient(to right, rgba(0, 0, 0, 1), rgba(0, 0, 0, 0))',
                position: 'absolute',
                zIndex:'1000'
            }}
        >
            
            <Navbar 
                sx={{
                    position:'relative'
                }}
            />

            
            
            <Box // Line 
                sx={{
                    borderBottom:'0.1rem solid #fefefe',
                    width:'10%',
                    paddingTop:'5rem'
                }}
            />

            <Box
                sx={{
                    padding:'3rem',
                    display:'flex',
                    flexDirection:'column',
                    width:'55%',
                    zIndex:'999'
                }}
            >
                <Box>
                    <Typography
                        variant='h1'
                        sx={{
                            color:'#fefefe',
                            fontSize:'4rem',
                            fontFamily:"ITC Avant Garde Gothic",
                            textTransform:'capitalize',
                            fontWeight:'500',
                            alignContent:'center',
                            '@media screen and (max-width:762px)':{
                                fontSize:'3rem'
                            }
                        }}
                    >
                        Innovative solution,<br />
                        unmatched Reliability <br /> 
                        across Every Sector
                    </Typography> 
                </Box>
                
                <Box //Button
                    sx={{
                        padding:'3rem',
                        width:'70%',
                        justifyContent:'center',
                        display:'flex'
                    }}
                >
                    <Button
                        variant='outlined'
                        href='/about'
                        sx={{
                            borderColor:'#fefefe',
                            borderWidth:'0.01rem',
                            borderRadius:'0',
                            color:'#fefefe',
                            width:'20rem',
                            transition: 'transform 0.5s ease-in-out', // transition smoothing
                            '&:hover':{
                                backgroundColor:'blue'
                            }
                        }}
                    >
                        <Typography
                            sx={{
                                fontStretch:'expanded',
                                fontSize:'1.3rem'
                            }}
                        >See more</Typography>
                        </Button>
                </Box>

            </Box>

            
        </Box>

    </Box>
  )
}

export default HomeHero